<!-- 质量检测管理 -->
<style scoped>
.samples-display {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
}

.sample-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  color: white;
}

.sample-pass {
  background-color: #52c41a;
}

.sample-fail {
  background-color: #ff4d4f;
}

.check-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.check-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
</style>
<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <!-- 搜索条件 -->
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="$refs.myTable.search()"
      >
        <a-form-model-item label="商品名称">
          <a-input
            placeholder="请输入商品名称"
            v-model="ajaxparams.goods_name_like"
          />
        </a-form-model-item>
        <a-form-model-item label="商品编号">
          <a-input
            placeholder="请输入商品编号"
            v-model="ajaxparams.goods_number_like"
          />
        </a-form-model-item>
        <a-form-model-item label="员工名称">
          <a-input
            placeholder="请输入员工名称"
            v-model="ajaxparams.employee_name_like"
          />
        </a-form-model-item>
        <a-form-model-item label="检测时间">
          <a-range-picker
            v-model="dateRange"
            @change="onDateChange"
            :placeholder="['开始日期', '结束日期']"
            format="YYYY-MM-DD"
          />
        </a-form-model-item>
        <a-form-model-item label="类型">
          <a-select
            style="width: 150px"
            v-model="ajaxparams.type"
            placeholder="请选择类型"
            allowClear
          >
            <a-select-option :value="1">女工计件</a-select-option>
            <a-select-option :value="2">全自动线</a-select-option>
            <a-select-option :value="3">内袋线</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button icon="search" @click="$refs.myTable.search()" type="primary"
            >搜索</a-button
          >
          <a-button @click="reset()" style="margin-left: 8px">重置</a-button>
        </a-form-model-item>

        <a-form-model-item>
          <a-button v-if="canExport" @click="doExport" type="primary"> 导出 </a-button>
        </a-form-model-item>
      </a-form-model>

      <div class="mt10">
        <a-button type="primary" @click="handleAdd">添加</a-button>
      </div>

      <!-- 表格 -->
      <MyTable
        :isSelection="false"
        class="mt10"
        :apiUrl="qualityGoods_index"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
      >
        <!-- 类型显示 -->
        <template slot="type" slot-scope="text">
          <a-tag :color="getTypeColor(text)">
            {{ getTypeText(text) }}
          </a-tag>
        </template>

        <!-- 各种状态显示 -->
        <template slot="seed_status" slot-scope="text">
          <a-tag :color="text == 1 ? 'green' : 'red'">
            {{ text == 1 ? "正确" : "错误" }}
          </a-tag>
        </template>
        <template slot="packing_status" slot-scope="text">
          <a-tag :color="text == 1 ? 'green' : 'red'">
            {{ text == 1 ? "无漏袋" : "有漏袋" }}
          </a-tag>
        </template>
        <template slot="cert_no_status" slot-scope="text">
          <a-tag :color="text == 1 ? 'green' : 'red'">
            {{ text == 1 ? "正确" : "错误" }}
          </a-tag>
        </template>
        <template slot="inner_bag_status" slot-scope="text">
          <a-tag :color="text == 1 ? 'green' : 'red'">
            {{ text == 1 ? "正确" : "错误" }}
          </a-tag>
        </template>
        <template slot="seal_status" slot-scope="text">
          <a-tag :color="text == 1 ? 'green' : 'red'">
            {{ text == 1 ? "正确" : "错误" }}
          </a-tag>
        </template>
        <template slot="label_status" slot-scope="text">
          <a-tag :color="text == 1 ? 'green' : 'red'">
            {{ text == 1 ? "正确" : "错误" }}
          </a-tag>
        </template>

        <!-- 样品检测显示 -->
        <template slot="samples" slot-scope="text">
          <div v-if="text" class="samples-display">
            <span
              v-for="(sample, index) in text.split('')"
              :key="index"
              class="sample-item"
              :class="sample == '1' ? 'sample-pass' : 'sample-fail'"
            >
              {{ index + 1 }}
            </span>
          </div>
          <span v-else>-</span>
        </template>

        <template slot="spec_type" slot-scope="text">
          <div style="max-width: 200px; word-break: break-word">{{ text }}</div>
        </template>

        <!-- 操作 -->
        <template slot="action" slot-scope="text, record">
          <a-button type="primary" size="small" @click="handleEdit(record)"
            >编辑</a-button
          >
          <a-popconfirm
            title="确定删除该记录吗？"
            @confirm="handleDelete(record)"
            okText="确定"
            cancelText="取消"
          >
            <a-button type="danger" size="small" style="margin-left: 8px"
              >删除</a-button
            >
          </a-popconfirm>
        </template>
      </MyTable>

      <!-- 添加/编辑模态框 -->
      <a-modal
        v-model="saveVisible"
        :title="isEdit ? '编辑检测记录' : '添加检测记录'"
        @ok="handleSave"
        :confirmLoading="saveLoading"
        width="800px"
      >
        <a-form-model
          ref="saveForm"
          :model="saveForm"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <!-- 类型选择 -->
          <a-form-model-item label="产线类型" prop="type">
            <a-radio-group
              v-model="saveForm.type"
              button-style="solid"
              @change="handleTypeChange"
              :disabled="isEdit"
            >
              <a-radio-button :value="3">内袋线</a-radio-button>
              <a-radio-button :value="1">女工线</a-radio-button>
              <a-radio-button :value="2">全自动线</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="检测日期" prop="create_date">
            <a-date-picker
              v-model="saveForm.create_date"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择日期"
              style="width: 100%"
              :allowClear="false"
            />
          </a-form-model-item>

          <!-- 员工信息 -->
          <a-form-model-item label="员工姓名" prop="employee_name">
            <a-select
              v-model="saveForm.employee_name"
              show-search
              placeholder="请输入或选择员工"
              allow-clear
              :filter-option="filterEmployeeOption"
              :not-found-content="
                employeeList.length === 0 ? '暂无数据' : '无匹配结果'
              "
            >
              <a-select-option
                v-for="d in employeeList"
                :key="d.id || d.name"
                :value="d.name"
                :pinyin="d.pinyin"
              >
                {{ d.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 机台号 (内袋线、全自动线) -->
          <a-form-model-item
            v-if="saveForm.type !== 1"
            label="机台号"
            prop="machine_id"
          >
            <a-input v-model="saveForm.machine_id" placeholder="请输入机台号" />
          </a-form-model-item>

          <!-- 商品信息 -->
          <a-form-model-item label="商品编号" prop="goods_number">
            <a-select
              v-model="saveForm.goods_number"
              show-search
              placeholder="输入编号搜索"
              optionFilterProp="label"
              allow-clear
              :dropdown-match-select-width="false"
              @change="onGoodsNumberChange"
            >
              <a-select-option
                v-for="g in goodsNumberList"
                :key="g.id"
                :value="g.goods_number"
                :label="g.goods_number"
              >
                {{ g.goods_number }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="商品名称" prop="goods_name">
            <a-select
              v-model="saveForm.goods_id_temp"
              show-search
              placeholder="输入名称搜索"
              optionFilterProp="label"
              allow-clear
              :dropdown-match-select-width="false"
              @change="onGoodsIdChange"
            >
              <a-select-option
                v-for="g in goodsList"
                :key="g.id"
                :value="g.id"
                :label="g.goods_name"
              >
                {{ g.goods_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="规格">
            <a-input v-model="saveForm.spec_type" disabled />
          </a-form-model-item>

          <!-- 生产数据 (女工线、全自动线) -->
          <template v-if="saveForm.type !== 3">
            <a-form-model-item label="总包数" prop="packing_num">
              <a-input-number
                v-model="saveForm.packing_num"
                style="width: 100%"
                :min="0"
                @change="calculateBoxes"
              />
            </a-form-model-item>
            <a-form-model-item
              :label="saveForm.spec_type == '点工' ? '工时' : '箱数'"
            >
              <a-input v-model="saveForm.box_num" disabled />
            </a-form-model-item>
            <a-form-model-item label="每箱/每小时单价" v-if="false">
              <!-- 隐藏字段，内部计算用 -->
              <a-input v-model="saveForm.unit_price" />
            </a-form-model-item>
          </template>

          <!-- 克重合格 (内袋线) -->
          <a-form-model-item
            v-if="saveForm.type === 3"
            label="克重合格"
            prop="inner_bag_status"
          >
            <a-radio-group v-model="saveForm.inner_bag_status">
              <a-radio :value="1">合格</a-radio>
              <a-radio :value="0">不合格</a-radio>
            </a-radio-group>
          </a-form-model-item>

          <!-- 质检项 -->
          <a-form-model-item label="质检巡查">
            <div class="check-group" style="position: relative; top: -8px">
              <div class="check-item">
                <span>种子与内袋规格是否相符</span>
                <a-radio-group v-model="saveForm.seed_status">
                  <a-radio :value="1">正确</a-radio>
                  <a-radio :value="0">错误</a-radio>
                </a-radio-group>
              </div>
              <div class="check-item">
                <span>{{
                  saveForm.type === 3 ? "内袋是否漏袋" : "包装袋是否正确"
                }}</span>
                <a-radio-group v-model="saveForm.packing_status">
                  <a-radio :value="1">正确</a-radio>
                  <a-radio :value="0">错误</a-radio>
                </a-radio-group>
              </div>

              <template v-if="saveForm.type !== 3">
                <div class="check-item">
                  <span>检疫证号是否正确</span>
                  <a-radio-group v-model="saveForm.cert_no_status">
                    <a-radio :value="1">正确</a-radio>
                    <a-radio :value="0">错误</a-radio>
                  </a-radio-group>
                </div>
                <div class="check-item">
                  <span>内袋数量是否正确</span>
                  <a-radio-group v-model="saveForm.inner_bag_status">
                    <a-radio :value="1">正确</a-radio>
                    <a-radio :value="0">错误</a-radio>
                  </a-radio-group>
                </div>
                <div class="check-item">
                  <span>封口是否紧密</span>
                  <a-radio-group v-model="saveForm.seal_status">
                    <a-radio :value="1">正确</a-radio>
                    <a-radio :value="0">错误</a-radio>
                  </a-radio-group>
                </div>
                <div class="check-item">
                  <span>箱标是否正确</span>
                  <a-radio-group v-model="saveForm.label_status">
                    <a-radio :value="1">正确</a-radio>
                    <a-radio :value="0">错误</a-radio>
                  </a-radio-group>
                </div>
              </template>
            </div>
          </a-form-model-item>

          <!-- 样品检测 (内袋线) -->
          <a-form-model-item v-if="saveForm.type === 3" label="样品检测">
            <div class="samples-display">
              <div
                v-for="(status, index) in sampleList"
                :key="index"
                style="margin-right: 10px; margin-bottom: 5px"
              >
                <span>样品{{ index + 1 }}: </span>
                <a-radio-group
                  :value="status"
                  @change="(e) => onSampleChange(index, e.target.value)"
                  button-style="solid"
                  size="small"
                >
                  <a-radio-button value="1">合格</a-radio-button>
                  <a-radio-button value="0">不合格</a-radio-button>
                </a-radio-group>
              </div>
              <a-button
                size="small"
                type="dashed"
                icon="plus"
                @click="addSample"
                v-if="sampleList.length < 10"
                >增加样品</a-button
              >
              <a-button
                size="small"
                type="danger"
                icon="delete"
                @click="removeSample"
                v-if="sampleList.length > 0"
                style="margin-left: 5px"
                >减少</a-button
              >
            </div>
          </a-form-model-item>

          <!-- 备注 -->
          <a-form-model-item label="备注" prop="remark" v-if="shouldShowRemark">
            <a-textarea
              v-model="saveForm.remark"
              placeholder="请输入备注"
              :rows="2"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  qualityGoods_index,
  packingGoods_savePackingInfo,
  packingGoods_goodsIndex,
  packingGoods_packingInfoDetail,
  packingGoods_delPackingInfo,
  packingEmployee_index,
} from "@/api/quality";
import MyTable from "@/components/myTable.vue";
import { packing } from "@/api/export";
import moment from "moment";

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export default {
  name: "QualityIndex",
  components: {
    MyTable,
  },
  data() {
    return {
      qualityGoods_index: qualityGoods_index,
      saveVisible: false,
      saveLoading: false,
      isEdit: false,

      ajaxparams: {},
      dateRange: [],

      // 搜索数据缓存
      employeeList: [],
      fetchingEmployees: false,
      goodsList: [],
      goodsNumberList: [],

      // 表单数据
      saveForm: this.getInitialForm(),
      sampleList: [], // 临时存储 samples 数组 ['1', '0', ...]

      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        create_date: [
          { required: true, message: "请选择检测日期", trigger: "change" },
        ],
        employee_name: [
          { required: true, message: "请输入员工姓名", trigger: "change" },
        ],
        goods_number: [
          { required: true, message: "请选择商品编号", trigger: "change" },
        ],
        goods_name: [
          { required: true, message: "请选择商品名称", trigger: "change" },
        ],
        machine_id: [
          { required: true, message: "请输入机台号", trigger: "blur" },
        ],
      },

      columns: [
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          width: 150,
          fixed: "left",
          scopedSlots: { customRender: "action" },
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
          key: "goods_name",
          width: 150,
          ellipsis: true,
        },
        {
          title: "商品编号",
          dataIndex: "goods_number",
          key: "goods_number",
          width: 120,
        },
        {
          title: "规格",
          dataIndex: "spec_type",
          key: "spec_type",
          width: 100,
          scopedSlots: { customRender: "spec_type" },
        },
        {
          title: "种子名称",
          dataIndex: "seed_name",
          key: "seed_name",
          width: 120,
          ellipsis: true,
        },
        {
          title: "类型",
          dataIndex: "type",
          key: "type",
          width: 100,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "员工名称",
          dataIndex: "employee_name",
          key: "employee_name",
          width: 100,
        },
        {
          title: "包装类型",
          dataIndex: "packing_type",
          key: "packing_type",
          width: 100,
        },
        {
          title: "总包数",
          dataIndex: "packing_num",
          key: "packing_num",
          width: 80,
        },
        {
          title: "箱数/小时数",
          dataIndex: "box_num",
          key: "box_num",
          width: 80,
        },
        {
          title: "机台号",
          dataIndex: "machine_id",
          key: "machine_id",
          width: 80,
        },
        {
          title: "种子状态",
          dataIndex: "seed_status",
          key: "seed_status",
          width: 100,
          scopedSlots: { customRender: "seed_status" },
        },
        {
          title: "内袋漏袋",
          dataIndex: "packing_status",
          key: "packing_status",
          width: 100,
          scopedSlots: { customRender: "packing_status" },
        },
        {
          title: "检疫证书",
          dataIndex: "cert_no_status",
          key: "cert_no_status",
          width: 100,
          scopedSlots: { customRender: "cert_no_status" },
        },
        {
          title: "内袋状态",
          dataIndex: "inner_bag_status",
          key: "inner_bag_status",
          width: 100,
          scopedSlots: { customRender: "inner_bag_status" },
        },
        {
          title: "封口状态",
          dataIndex: "seal_status",
          key: "seal_status",
          width: 100,
          scopedSlots: { customRender: "seal_status" },
        },
        {
          title: "箱标状态",
          dataIndex: "label_status",
          key: "label_status",
          width: 100,
          scopedSlots: { customRender: "label_status" },
        },
        {
          title: "样品检测",
          dataIndex: "samples",
          key: "samples",
          width: 120,
          scopedSlots: { customRender: "samples" },
        },
        {
          title: "总工费",
          dataIndex: "total_price",
          key: "total_price",
          width: 100,
        },
        {
          title: "用时(秒)",
          dataIndex: "spend_time",
          key: "spend_time",
          width: 100,
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          width: 150,
          ellipsis: true,
        },
        {
          title: "检测日期",
          dataIndex: "create_date",
          key: "create_date",
          width: 140,
        },
      ],
    };
  },
  computed: {
    shouldShowRemark() {
      // 内袋线(3)：直接隐藏
      if (this.saveForm.type === 3) return false;
      // 女工线(1) 和 全自动线(2)：只有出错才显示
      return (
        this.saveForm.seed_status === 0 || this.saveForm.packing_status === 0
      );
    },
  },
  created() {
    this.loadEmployees();
    this.loadGoods();
  },
  methods: {
    getInitialForm() {
      return {
        type: 3, // 默认内袋线
        create_date: moment().format("YYYY-MM-DD"),
        employee_name: undefined,
        goods_number: undefined,
        goods_name: undefined,
        goods_id: 0,
        goods_id_temp: undefined, // 用于商品名称选择的临时字段
        spec_type: "",
        seed_name: "",
        machine_id: "",
        packing_num: 0,
        box_num: 0,
        unit_price: 0,
        num_per_box: 0,
        inner_bag_status: 1, // 1合格 0不合格
        seed_status: 1,
        packing_status: 1,
        cert_no_status: 1,
        inner_bag_status: 1,
        seal_status: 1,
        label_status: 1,
        remark: "",
        samples: "",
      };
    },

    //导出
    doExport() {
      packing(this.ajaxparams).then(
        (res) => {
          this.$message.success("添加导出队列成功");
          this.$db.set("is_export", 1);
        },
        (err) => {
          this.$message.warning("导出失败");
        }
      );
    },
    reset() {
      this.ajaxparams = {};
      this.dateRange = [];
      this.$refs.myTable.search();
    },
    onDateChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.ajaxparams.create_date_between = `${dateStrings[0]} - ${dateStrings[1]}`;
      } else {
        delete this.ajaxparams.create_date_between;
      }
    },
    getTypeText(type) {
      const typeMap = {
        1: "女工计件",
        2: "全自动线",
        3: "内袋线",
      };
      return typeMap[type] || "未知";
    },
    getTypeColor(type) {
      const colorMap = {
        1: "blue",
        2: "green",
        3: "orange",
      };
      return colorMap[type] || "default";
    },

    // 打开添加
    handleAdd() {
      this.isEdit = false;
      this.saveForm = this.getInitialForm();
      this.sampleList = ["", "", "", "", ""]; // 默认5个
      this.saveVisible = true;

      // 如果列表为空，尝试重新加载
      if (this.goodsList.length === 0) {
        this.loadGoods();
      }
      if (this.employeeList.length === 0) {
        this.loadEmployees();
      }

      this.$nextTick(() => {
        if (this.$refs.saveForm) this.$refs.saveForm.clearValidate();
      });
    },

    // 打开编辑
    handleEdit(record) {
      this.isEdit = true;
      this.saveLoading = true;
      packingGoods_packingInfoDetail({ id: record.id })
        .then((res) => {
          console.log("dodod");
          console.log(res);
          this.saveLoading = false;
          if (res) {
            // 兼容可能返回 code 200 或直接 result
            const data = res.result || res;

            // 数据转换

            // 尝试从 goodsList 中获取 num_per_box (如果详情中没有)
            let numPerBox = Number(data.num_per_box) || 0;
            let unitPrice = Number(data.unit_price) || 0;

            const foundGood = this.goodsList.find(
              (g) => g.goods_number === data.goods_number
            );
            var goodsId = foundGood ? Number(foundGood.id) : 0;
            if (foundGood) {
              if (!numPerBox) numPerBox = Number(foundGood.num_per_box) || 0;
              if (!unitPrice) unitPrice = Number(foundGood.unit_price) || 0;
            }

            // 如果 num_per_box 仍然为0，但有 packing_num 和 box_num，则反向计算
            if (
              !numPerBox &&
              data.packing_num &&
              data.box_num &&
              data.box_num > 0
            ) {
              numPerBox = (
                Number(data.packing_num) / Number(data.box_num)
              ).toFixed(0);
            }

            this.saveForm = {
              id: data.id,
              type: data.type,
              create_date:
                data.create_date && data.create_date != "0000-00-00"
                  ? moment(data.create_date).format("YYYY-MM-DD")
                  : moment().format("YYYY-MM-DD"),
              employee_name: data.employee_name,
              goods_number: data.goods_number || data.goods_no,
              goods_name: data.goods_name,
              goods_id: goodsId,
              goods_id_temp: goodsId, // 用于商品名称选择器
              spec_type: data.spec_type,
              seed_name: data.seed_name || "",
              machine_id: data.machine_id,
              packing_num: data.packing_num,
              box_num: data.box_num,
              unit_price: unitPrice,
              total_price: data.total_price, // 保留原始总价格
              num_per_box: numPerBox,
              inner_bag_status: data.inner_bag_status,
              seed_status: data.seed_status,
              packing_status: data.packing_status,
              cert_no_status: data.cert_no_status,
              inner_bag_status: data.inner_bag_status,
              seal_status: data.seal_status,
              label_status: data.label_status,
              remark: data.remark,
              samples: data.samples,
            };

            // 处理样品
            if (data.samples) {
              this.sampleList = data.samples.split("");
            } else {
              if (this.saveForm.type === 3) {
                this.sampleList = ["", "", "", "", ""];
              } else {
                this.sampleList = [];
              }
            }

            // 检查当前 goodsList 是否包含该商品，如果不包含则添加，避免显示 ID
            if (this.goodsList.length > 0) {
              const exists = this.goodsList.some((g) => g.id === goodsId);
              if (!exists && data.goods_name) {
                this.goodsList.push({
                  id: goodsId,
                  goods_name: data.goods_name,
                  goods_number: data.goods_number,
                  num_per_box: numPerBox,
                  unit_price: unitPrice,
                  spec_type: data.spec_type,
                  seed_name: data.seed_name || "",
                });
              }
            } else if (data.goods_name) {
              // 如果列表为空（可能是搜索模式或加载失败），则初始化为当前商品
              this.goodsList = [
                {
                  id: goodsId,
                  goods_name: data.goods_name,
                  goods_number: data.goods_number,
                  num_per_box: numPerBox,
                  unit_price: unitPrice,
                  spec_type: data.spec_type,
                  seed_name: data.seed_name || "",
                },
              ];
            }

            // 确保 goodsNumberList 也有数据
            if (this.goodsNumberList.length === 0 && data.goods_number) {
              this.goodsNumberList = [
                {
                  id: goodsId,
                  goods_name: data.goods_name,
                  goods_number: data.goods_number,
                  num_per_box: numPerBox,
                  unit_price: unitPrice,
                  spec_type: data.spec_type,
                  seed_name: data.seed_name || "",
                },
              ];
            }

            // 确保 employeeList 也有数据
            if (this.employeeList.length === 0 && data.employee_name) {
              this.employeeList = [{ name: data.employee_name }];
            }

            this.saveVisible = true;
          } else {
            this.$message.error(res.msg || "获取详情失败");
          }
        })
        .catch((err) => {
          this.saveLoading = false;
          this.$message.error("网络错误");
        });
    },

    // 删除
    handleDelete(record) {
      packingGoods_delPackingInfo({ id: record.id }).then((res) => {
        if (res) {
          this.$message.success("删除成功");
          this.$refs.myTable.search();
        } else {
          this.$message.error(res.msg || "删除失败");
        }
      });
    },

    // 保存
    handleSave() {
      this.$refs.saveForm.validate((valid) => {
        if (valid) {
          this.saveLoading = true;

          // 校验样品 (如果是内袋线 type=3)
          if (this.saveForm.type === 3) {
            // 如果样品列表为空，初始化为5个空样品
            if (this.sampleList.length === 0) {
              this.sampleList = ["", "", "", "", ""];
            }

            for (let i = 0; i < this.sampleList.length; i++) {
              if (!this.sampleList[i]) {
                this.$message.error(`请选择样品${i + 1}的检测结果`);
                this.saveLoading = false;
                return;
              }
            }
          }

          // 校验备注必填 (针对 女工线 和 全自动线)
          if (this.shouldShowRemark && this.saveForm.type !== 3) {
            if (!this.saveForm.remark || !this.saveForm.remark.trim()) {
              this.$message.error("请填写备注");
              this.saveLoading = false;
              return;
            }
          }

          // 计算总价
          let totalPrice = 0;
          if (this.saveForm.unit_price && this.saveForm.box_num) {
            totalPrice = (
              parseFloat(this.saveForm.unit_price) *
              parseFloat(this.saveForm.box_num)
            ).toFixed(2);
          }
          console.log(totalPrice);
          console.log(this.saveForm);

          const submitData = {
            ...this.saveForm,
            packing_type: "包", // 默认
            total_price: totalPrice,
            samples: this.saveForm.type === 3 ? this.sampleList.join("") : "",
          };

          packingGoods_savePackingInfo(submitData)
            .then((res) => {
              if (res) {
                this.$message.success(this.isEdit ? "修改成功" : "添加成功");
                this.saveVisible = false;
                this.$refs.myTable.search();
              } else {
                this.$message.error(res.msg || "保存失败");
              }
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      });
    },

    handleTypeChange() {
      // 切换类型时的一些重置操作
      if (!this.isEdit) {
        this.saveForm.machine_id = "";
        this.saveForm.seed_status = 1;
        this.saveForm.packing_status = 1;
        if (this.saveForm.type === 3) {
          this.sampleList = ["", "", "", "", ""];
        } else {
          this.sampleList = [];
        }
      }
    },

    filterEmployeeOption(input, option) {
      const text = option.componentOptions.children[0].text.toLowerCase();
      const pinyin = (option.data.attrs.pinyin || "").toLowerCase();
      const inputValue = input.toLowerCase();
      return text.includes(inputValue) || pinyin.includes(inputValue);
    },

    // 加载所有员工
    loadEmployees() {
      packingEmployee_index({ page: 1, limit: 999 })
        .then((res) => {
          if (res && res.list && Array.isArray(res.list)) {
            // 过滤掉无效数据
            const validList = res.list.filter((item) => item && item.name);
            this.employeeList = validList;
          } else {
            this.employeeList = [];
          }
        })
        .catch((err) => {
          this.employeeList = [];
          this.$message.error("加载员工数据失败");
        });
    },

    loadGoods() {
      packingGoods_goodsIndex({ page: 1, limit: 99999 })
        .then((res) => {
          if (res && res.list && Array.isArray(res.list)) {
            // 过滤掉无效数据，确保每个商品都有必要的字段
            const validList = res.list
              .filter((item) => item && (item.goods_name || item.goods_number))
              .map((item) => ({
                ...item,
                id: Number(item.id), // 确保 ID 是数字类型
              }));
            this.goodsList = validList;
            this.goodsNumberList = validList;
            if (validList.length === 0) {
              this.$message.warning("暂无商品数据");
            }
          } else {
            this.goodsList = [];
            this.goodsNumberList = [];
          }
        })
        .catch((err) => {
          this.goodsList = [];
          this.goodsNumberList = [];
          this.$message.error("加载商品数据失败");
        });
    },

    onGoodsIdChange(goodsId) {
      // 通过 ID 选择商品（商品名称选择器）
      const id = Number(goodsId);
      const goods = this.goodsList.find((item) => item.id === id);
      if (goods) {
        this.fillGoodsInfo(goods);
      }
    },

    onGoodsNameChange(value) {
      const goods = this.goodsList.find((item) => item.goods_name === value);
      if (goods) {
        this.fillGoodsInfo(goods);
      }
    },

    onGoodsNumberChange(value) {
      const goods = this.goodsNumberList.find(
        (item) => item.goods_number === value
      );
      if (goods) {
        this.fillGoodsInfo(goods);
      }
    },

    fillGoodsInfo(goods) {
      this.saveForm.goods_id = goods.id;
      this.saveForm.goods_id_temp = goods.id; // 同步更新商品名称选择器的绑定值
      this.saveForm.goods_name = goods.goods_name;
      this.saveForm.goods_number = goods.goods_number;
      this.saveForm.spec_type = goods.spec_type;
      this.saveForm.seed_name = goods.seed_name || "";
      this.saveForm.num_per_box = Number(goods.num_per_box) || 0;
      this.saveForm.unit_price = Number(goods.unit_price) || 0;
      this.calculateBoxes();
    },

    calculateBoxes() {
      if (
        this.saveForm.type !== 3 &&
        this.saveForm.num_per_box > 0 &&
        this.saveForm.packing_num
      ) {
        this.saveForm.box_num = (
          this.saveForm.packing_num / this.saveForm.num_per_box
        ).toFixed(4);
      } else {
        this.saveForm.box_num = 0;
      }
    },

    // 样品相关
    addSample() {
      if (this.sampleList.length < 10) {
        this.sampleList.push("");
      }
    },
    removeSample() {
      if (this.sampleList.length > 0) {
        this.sampleList.pop();
      }
    },
    onSampleChange(index, val) {
      // Vue 不能检测数组索引赋值，需使用 $set 或者 splice
      this.$set(this.sampleList, index, val);
    },
  },
};
</script>
